import classNames from 'classnames';
import * as React from 'react';
import { Body } from 'vet-bones/design-system/components';

export interface OrganizationStepperProps {
  currentStepIdx: number;
  steps: string[];
}

export const OrganizationStepper: React.VFC<OrganizationStepperProps> = ({
  currentStepIdx,
  steps,
}) => (
  <div className="organization-stepper">
    {steps.map((step, stepIdx) => (
      <div
        key={step}
        className={classNames('organization-stepper-step', {
          'organization-stepper-step--active': stepIdx === currentStepIdx,
          'organization-stepper-step--completed': stepIdx < currentStepIdx,
        })}
      >
        <div className="organization-stepper-step-indicator">
          <div className="organization-stepper-step-indicator-connector organization-stepper-step-indicator-connector--left" />
          <div className="organization-stepper-step-indicator-circle" />
          <div className="organization-stepper-step-indicator-connector organization-stepper-step-indicator-connector--right" />
        </div>
        <Body
          className="organization-stepper-step-label"
          size="sm"
          weight="semibold"
        >
          {step}
        </Body>
      </div>
    ))}
  </div>
);
